export enum LocalStorage {
  LOGATE_CHAT_MESSAGES = 'logate-chat-messages',
  LOGATE_CHAT_CHAT_SESSION_ID = 'logate-chat-chat-session-id',
  LOGATE_CHAT_OPERATOR_NAME = 'logate-chat-operator-name',
  LOGATE_CHAT_ENTRY_DATA = 'logate-chat-entry-data',
  LOGATE_CHAT_STATE = 'logate-chat-state',
  LOGATE_CHAT_CLOSED_BY_AGENT = 'logate-chat-closed-by-agent',
  LOGATE_CHAT_SURVEY_LINK = 'logate-chat-survey-link',
  LOGATE_CHAT_UNREAD_MESSAGES = 'logate-chat-unread-messages',
}
